import { useCurrentState } from '../../xstate/app.xstate';
import { filterErrorTags } from './helpers';
import { ErrorTags } from './types';

export const useErrorTag = (tags?: ErrorTags | ErrorTags[]) => {
  const userTags = filterErrorTags(tags);
  const currentState = useCurrentState();
  const statesArr = Object.values(currentState);
  const isLocalError = statesArr.some((state) => state.hasTag(ErrorTags.local));
  const isXstateError = statesArr.some((state) =>
    state.hasTag(ErrorTags.xstate)
  );
  const isGlobalError = statesArr.some((state) =>
    state.hasTag(ErrorTags.global)
  );
  const hasUserTags = !userTags.length
    ? false
    : statesArr.some((state) =>
        userTags.every((tag) => state.hasTag(tag as string))
      );

  return {
    isXstateError,
    isLocalError,
    isGlobalError,
    hasUserTags,
  };
};
